export function tidySearch(formData: FormData): void {
  formData.set('q', String(formData.get('q') ?? '').trim())

  for (const [name, value] of [...formData.entries()]) {
    if (value === '') formData.delete(name)
  }
}

export interface SegmentRoute {
  readonly path: string
  readonly fields: Readonly<Record<string, string>>
  readonly within: Readonly<Record<string, string>>
}

export type SegmentRoutes = readonly SegmentRoute[]

type Fields = Pick<FormData, 'get'>

export function segmentDestination(
  fields: Fields,
  routes: SegmentRoutes,
): { path: string; carried: string[] } | null {
  const value = (name: string) => String(fields.get(name) ?? '')
  const route = routes.find(
    ({ fields: wanted, within }) =>
      Object.entries(wanted).every(([name, expected]) => value(name) === expected) &&
      Object.entries(within).every(([name, expected]) => ['', expected].includes(value(name))),
  )

  return route
    ? { path: route.path, carried: [...Object.keys(route.fields), ...Object.keys(route.within)] }
    : null
}

// Read the controls themselves: building a FormData would fire `formdata`, whose handler strips the segment's field.
export function formFields(form: HTMLFormElement): Fields {
  return {
    get(name) {
      const field = form.elements.namedItem(name)
      return field instanceof HTMLSelectElement ||
        field instanceof HTMLInputElement ||
        field instanceof RadioNodeList
        ? field.value
        : null
    },
  }
}
